const getImageDataUrl = (image) => {
  if (!image) return null;
  return (
    image.fileDataBase64 ||
    image.base64 ||
    image.imageUrl ||
    image.url ||
    image.image ||
    null
  );
};

const toMediaType = (image) => {
  if (image?.type) return image.type;
  const url = getImageDataUrl(image);
  if (url?.startsWith('data:')) {
    const match = url.match(/^data:([^;]+);/);
    if (match?.[1]) return match[1];
  }
  return 'image/jpeg';
};

export const attachedImagesToFileParts = (attachedImages = [], referenceArt = null) => {
  const parts = [];

  attachedImages.forEach((image) => {
    const url = getImageDataUrl(image);
    if (!url) return;
    parts.push({
      type: 'file',
      mediaType: toMediaType(image),
      url,
      filename: image.name || image.fileName || 'image.jpg',
    });
  });

  if (referenceArt) {
    const url = getImageDataUrl(referenceArt);
    if (url) {
      parts.push({
        type: 'file',
        mediaType: toMediaType(referenceArt),
        url,
        filename: referenceArt.name || referenceArt.fileName || 'logo.jpg',
      });
    }
  }

  return parts;
};

export const getAttachedImagePreviewUrl = (image) => getImageDataUrl(image);

export const extractAttachedImageUrls = (attachedImages = []) =>
  attachedImages
    .map((image) => getImageDataUrl(image))
    .filter((url) => typeof url === 'string' && url.trim());
